import { AfterContentChecked, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { DataService as CoreDataService, Query, QueryObjectsModel } from '@barthauer/abc/core/data';

import { ResourceManager } from '@barthauer/abc/core/resources';
import { locale } from 'devextreme/localization';
import { Subscription } from 'rxjs';
import { AppService } from '../services/app.service';
import { DataService, ObjectKeys } from '../services/data.service';
import { LanguageService } from '../services/language.service';
import { CompaniesService, IProjectDependency, WebStorageType } from '../shared/companies/companies.service';
import { NotificationService } from '../services/notification.service';
import { ToastType } from '../models/enumeration-list.model';

@Component({
  selector: 'ubt-geods-companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompaniesComponent implements OnInit, AfterViewInit, OnDestroy,AfterContentChecked {
  public navigateUrlPath: string = 'dashboard';
  private currentLanguage: string | null;
  public configDependencies: IProjectDependency[] = [
    {
      name: 'projectId',
      storageType: WebStorageType.LocalStorage,
    },
    {
      name: 'projectName',
      storageType: WebStorageType.LocalStorage,
    },
  ];
  public companyIdDependency: IProjectDependency = {
    name: 'currentCompany',
    storageType: WebStorageType.SessionStorage,
  };
  public companyNameDependency: IProjectDependency = {
    name: 'companyName',
    storageType: WebStorageType.SessionStorage,
  };
  public filterOptions = [];
  private subscriptions: Subscription[] = [];

  constructor(
    public dataService: DataService,
    private coreDataService: CoreDataService,
    private companiesService: CompaniesService,
    private appService: AppService,
    private languageService: LanguageService,
    private cdr: ChangeDetectorRef, private notificationService: NotificationService,
  ) {}
 public ngAfterContentChecked(): void {
    if(this.dataService.unothorized) {
      this.notificationService.callNotification({ message:this.dataService.res('Ubt-Autorization'), type: ToastType.INFO })
      this.dataService.unothorized = false
    }
  }

  public ngOnInit(): void {
    this.filterOptions = [
      { id: 0, name: this.dataService.res('Ubt-Filter-All') },
      { id: 1, name: this.dataService.res('Ubt-Filter-Company-with-Projects') },
    ];
    this.languageService.localStorageChanges$.subscribe((value) => {
      this.currentLanguage = value;
      this.translatefilteroption(value);
    });
  }

  translatefilteroption(val: string) {
    if (val == null || val === 'de') {
      locale('de');
    } else {
      locale('en');
    }
    ResourceManager.changeLanguage(val);
    this.cdr.detectChanges();
  }

  public ngAfterViewInit(): void {
    this.companiesService.filterCompanyData(1);
  
      
    
  }

  public clickProject(project) {
    this.appService.switchTreeViewToProject(true);
    localStorage.setItem('projectId', project.Id);
    localStorage.setItem('projectName', project.Label);
    this.appService.callProjectName(project.Label);
  }

  public clickCompany(company) {
    this.appService.switchTreeViewToCompany(true);
    localStorage.setItem('currentCompany', company.Id);
    localStorage.setItem('companyName', company.Name);
    this.companiesService.prepareTitleCompany(company.Name);
    this.companiesService.selectedCompanyData(true);
    sessionStorage.removeItem('projectName');
  }

  public selectLastProjectUpdated(project) {
    localStorage.setItem('companyName', project['ParentAddress']);
    localStorage.setItem('currentCompany', project['ParentId']);
    localStorage.setItem('projectName', project.Label);
    localStorage.setItem('projectId', project.Id);
    this.companiesService.prepareTitleCompany(project['ParentAddress']);
    this.appService.switchTreeViewToProject(true);
    this.companiesService.selectedProjectData(project);
  }

  public prepareFiltredData(columns) {
    const query: Query = new Query();
    query.ObjectType = ObjectKeys.ADDRESS;
    query.Columns = columns;
    query.OPath = 'Count(xmtProjects) > 0';
    const queryCompany: QueryObjectsModel = new QueryObjectsModel();
    queryCompany.ObjectQueries = [query];

    this.subscriptions.push(
      this.coreDataService.executeReadObjectsQuery(queryCompany).subscribe((companiesData) => {
        if (Array.isArray(companiesData) && companiesData.length > 0)
          this.companiesService.filterCompanyData(companiesData);
      })
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
